export default __webpack_public_path__ + "static/media/facebook.551fbe7a.png";